import { ColumnText } from '@/components/ui/data-display/column-text/ColumnText';

export const TextColumn = ({ data, isRelation, ...props }) => {
  const hasRelations = data?.meta?.has_relations;
  return (
    <ColumnText
      {...props}
      isRelation={hasRelations}
      data={{
        title: data?.fields?.title || null,
        text: data?.fields?.text || null,
      }}
    />
  );
};
